import { GA4Event} from "./GA4Event";

export function buildBookNotFoundBackNavigate(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("book_not_found_back_navigate", {
		search_input: attributes.search_input || '',
		interaction: attributes.interaction || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
